import { render, staticRenderFns } from "./DynamicRadioGroup.vue?vue&type=template&id=345d82de&"
import script from "./DynamicRadioGroup.vue?vue&type=script&lang=js&"
export * from "./DynamicRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports